<template>
  <div class="control">
    <RuleModeAlert
      @close="hideRuleModeAlert()"
      @reTry="controlClick(1)"
      v-if="isShowRuleModeAlert"
    ></RuleModeAlert>
    <ConnectAlert
      :isFailed="isShowConnectFailed"
      :name="connectName"
      :connectRet="connectRet"
      @close="closeConnectAlert"
      v-if="isShowConnectAlert"
      :rule="rule"
    ></ConnectAlert>
    <MessageTip
      v-if="messageFlag"
      :messageType="messageType"
      @closeMessageAlertClick="closeMessageAlertClick"
      @wakeupClick="wakeupClick"
      @showWakeupTips="showWakeupTips"
      @goPay="onPayClick"
    ></MessageTip>
    <WakeUpTipsAlert
      @ignore="ignoreWakeUpTips"
      @wakeup="wakeupClick"
      @close="closeWakeUpTipsAlert"
      v-if="isShowWakeUpTipsAlert"
    ></WakeUpTipsAlert>
    <WakeUpTipsSuccessAlert
      @close="closeWakeUpSuccessTipsAlert"
      @showWakeupTips="showWakeUpTipsAlert"
      v-if="isShowWakeUpSuccessTipsAlert"
    ></WakeUpTipsSuccessAlert>
    <ServerTimesLimitAlert
      @onCancelClick="hideServerTimesLimitAlert(false)"
      @onPayClick="onPayClick"
      v-if="isShowServerTimesLimitAlert"
    ></ServerTimesLimitAlert>
    <ServerTimesTipsAlert
      :times="leftTimes"
      @onCancelClick="hideServerTimesTipsAlert(false)"
      v-if="isShowServerTimesTipsAlert"
    ></ServerTimesTipsAlert>

    <NasWebportFailed
      @close="closeConnectAlert"
      v-if="isShowNasWebportFailded"
    ></NasWebportFailed>

    <div class="diy-map-tip" v-if="isShowMappingResultAlert">
      <div class="diy-wrap">
        <div class="close-icon" @click="closeMapClick"></div>
        <div class="diy-title">高级映射</div>
        <div class="diy-text">内网主机: {{ item.ip_str }}:{{ item.port }}</div>
        <div class="diy-text2">映射地址</div>
        <div class="diy-text3">127.0.0.1:{{ mappingPort }}</div>
        <div class="diy-btns">
          <div
            class="btn copy-class"
            :data-clipboard-text="'127.0.0.1:' + mappingPort"
            @click="copyClick"
          >
            <div class="btn-icon"></div>
            复制地址
          </div>
          <div class="btn btn2" @click="jumpBrowser">
            <div class="btn-icon"></div>
            浏览器访问
          </div>
        </div>
        <div class="tip" v-if="tip">{{ tip }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectAlert from "@/components/ConnectAlert.vue";
import MessageTip from "@/components/MessageTip.vue";
import WakeUpTipsAlert from "@/components/WakeUpTipsAlert.vue";
import RuleModeAlert from "@/components/Node/RuleModeAlert.vue";
import NasWebportFailed from "@/components/remote/NasWebportFailed.vue";
import ServerTimesLimitAlert from "@/components/Node/ServerTimesLimitAlert.vue";
import ServerTimesTipsAlert from "@/components/Node/ServerTimesTipsAlert.vue";
import WakeUpTipsSuccessAlert from "@/components/WakeUpTipsSuccessAlert.vue";
import { mapActions } from "vuex";
import Clipboard from "clipboard";
export default {
  data: function () {
    return {
      messageFlag: false,
      messageType: "",
      connectName: "",
      connectRet: "",
      rule: 0,
      leftTimes: 0,
      isShowNasWebportFailded: false,
      isShowConnectFailed: false,
      isShowConnectAlert: false,
      isShowWakeUpTipsAlert: false,
      isShowRuleModeAlert: false,
      isShowWakeUpSuccessTipsAlert: false,
      isShowServerTimesLimitAlert: false,
      isShowServerTimesTipsAlert: false,
      isShowMappingResultAlert: false,
      mappingPort: 0,
      tip: "",
    };
  },
  components: {
    ConnectAlert,
    MessageTip,
    WakeUpTipsAlert,
    WakeUpTipsSuccessAlert,
    RuleModeAlert,
    ServerTimesLimitAlert,
    ServerTimesTipsAlert,
    NasWebportFailed,
  },
  props: ["item", "dev", "type", "isVipServer"],
  methods: {
    ...mapActions([
      "portal",
      "createTunnel",
      "startMapSrv",
      "sendUserlog",
      "webWakeup",
      "scan",
      "getServerTimes",
      "updateServerTimes",
    ]),
    showNasWebportFailedAlert: function () {
      this.isShowNasWebportFailded = true;
    },
    showMappingResultAlert: function () {
      let _that = this;
      _that.isShowMappingResultAlert = true;
    },
    hideMappingResultAlert: function (isShowMore) {
      let _that = this;
      _that.isShowMappingResultAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    copyClick: function () {
      let _that = this;
      let clipboard = new Clipboard(".copy-class");
      clipboard.on("success", (e) => {
        _that.tip = "复制成功";
        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        _that.tip = "复制失败";
        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        clipboard.destroy();
      });

      if (_that.$store.state.client == "windows") {
        _that.tip = "复制成功";
        setTimeout(function () {
          _that.tip = "";
        }, 1500);
      }
    },
    closeMapClick: function () {
      let _that = this;
      _that.$emit("closeClick");
    },
    closeWakeUpSuccessTipsAlert: function (isShowMore) {
      let _that = this;
      _that.isShowWakeUpSuccessTipsAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    showWakeUpSuccessTipsAlert: function () {
      let _that = this;
      _that.isShowWakeUpSuccessTipsAlert = true;
    },
    showServerTimesLimitAlert: function () {
      let _that = this;
      _that.isShowServerTimesLimitAlert = true;
    },
    hideServerTimesLimitAlert: function (isShowMore) {
      let _that = this;
      _that.isShowServerTimesLimitAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    showServerTimesTipsAlert: function () {
      let _that = this;
      _that.isShowServerTimesTipsAlert = true;
    },
    hideServerTimesTipsAlert: function (isShowMore) {
      let _that = this;
      _that.isShowServerTimesTipsAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    closeMessageAlertClick: function () {
      let _that = this;
      _that.messageFlag = false;
      _that.$emit("closeClick");
    },
    ignoreWakeUpTips: function () {
      let _that = this;
      _that.$common.localStorage.setItem("ignoreRemoteWakeupTips", true);
      _that.closeWakeUpTipsAlert();
    },
    showConnectFailed: function () {
      let _that = this;
      if (_that.isShowConnectAlert) {
        _that.isShowConnectFailed = true;
      }
    },
    showRuleModeAlert: function () {
      this.isShowRuleModeAlert = true;
    },
    hideRuleModeAlert: function (isShowMore) {
      let _that = this;
      _that.isShowRuleModeAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    closeWakeUpTipsAlert: function () {
      let _that = this;
      _that.isShowWakeUpTipsAlert = false;
      _that.$emit("closeClick");
    },
    showWakeUpTipsAlert: function () {
      let _that = this;
      // console.log("showWakeUpTipsAlert");
      _that.closeWakeUpSuccessTipsAlert(true);
      _that.isShowWakeUpTipsAlert = true;
    },
    wakeupClick: function () {
      let _that = this;
      console.log("wakeupClick", _that.dev, _that.item);
      _that.showWakeUpSuccessTipsAlert();

      if (_that.$store.state.client == "windows") {
        if (window.external.goWakeUp) {
          let ret = window.external.goWakeUp(_that.item.mac);
          _that.sendUserlog(["wakeup_ret", ret + ""]);
        }
      } else {
        _that.webWakeup([
          _that.dev.peerid,
          _that.item.mac,
          function (err, data) {
            _that.sendUserlog(["wakeup_result", JSON.stringify(data)]);
            if (data && !data.rtn) {
              _that.scan([_that.dev.peerid, function (err, data) {}]);
            }
          },
        ]);
      }
    },
    showWakeupTips: function () {
      let _that = this;
      _that.messageFlag = true;
      _that.messageType = "showRemoteWakeup";
    },
    onPayClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/vip" });
    },
    closeConnectAlert: function (isShowMore) {
      let _that = this;
      _that.isShowConnectFailed = false;
      _that.isShowConnectAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    showConnectAlert: function () {
      let _that = this;
      _that.isShowConnectAlert = true;
    },
    controlClick: function (rule) {
      let _that = this;
      if (_that.$store.state.user.vip_left > 0) {
        _that.doControlClick();
      } else {
        if (_that.isVipServer) {
          _that.getServerTimes([
            function (err, data) {
              let leftTimes =
                data && data.data && data.data.times ? data.data.times : 0;
              if (leftTimes > 0) {
                _that.doControlClick(rule);
              } else {
                _that.showServerTimesLimitAlert();
              }
            },
          ]);
        } else {
          _that.doControlClick(rule);
        }
      }
    },
    doControlClick: function (rule) {
      let _that = this;
      rule = rule ? rule : 0;
      if (_that.item.rule) {
        rule = _that.item.rule;
      }
      // 高级服务都走代理模式
      if (_that.isVipServer) {
        rule = 1;
      }
      _that.rule = rule;
      _that.connectName = _that.item.name;
      _that.connectRet = 0;
      _that.showConnectAlert();
      _that.hideRuleModeAlert(true);

      if (
        _that.$store.state.client != "windows" &&
        _that.$store.state.client != "mac"
      ) {
        if (_that.item.port == 3389 || _that.item.port == 5900) {
          _that.closeConnectAlert(true);
          _that.messageFlag = true;
          _that.messageType = "showDownloadWindowsApp";
        }
      }

      setTimeout(function () {
        _that.controlDelay(rule);
      }, 1500);
    },
    controlDelay: function (rule) {
      let _that = this;
      rule = rule ? rule : 0;
      _that.rule = rule;
      // _that.showRuleModeAlert();
      // return;
      // console.log("controlClick", _that.item, _that.dev);
      _that.showConnectAlert();
      _that.hideRuleModeAlert(true);
      let ip = _that.$common.ipConvert(_that.item.ip);
      let port = _that.item.port ? _that.item.port : 0;
      _that.connectName = _that.item.name;
      _that.connectRet = 0;
      _that.sendUserlog(["control_click", ip + ":" + port + "," + rule]);
      _that.sendUserlog([
        "control_" + port + "_click",
        ip + ":" + port + "," + rule,
      ]);

      if (_that.$store.state.client == "windows") {
        let ret = 1;
        if (_that.item.port == 3389) {
          if (window.external.goMstsc) {
            ret = window.external.goMstsc(ip, 3389, 0);

            if (ret == 0 || ret == -2023) {
              _that.sendUserlog(["remote_s_windowsDesktop", ip + "|" + "3389"]);
            } else {
              _that.sendUserlog(["remote_f_windowsDesktop", ip + "|" + "3389"]);
            }
          }

          _that.connectRet = ret;
          setTimeout(function () {
            // for test
            // ret = 0;
            if (ret == 0 || ret == -2023) {
              _that.doControlSuccess();
            } else {
              _that.showConnectFailed();
            }
          }, 500);
        } else if (_that.item.port == 5900) {
          if (window.external.goVNCViewer) {
            ret = window.external.goVNCViewer("tvnviewer.exe", ip, 5900, 0);

            if (ret == 0 || ret == -2023) {
              _that.sendUserlog(["remote_s_windowsVNC", ip + "|" + "5900"]);
            } else {
              _that.sendUserlog(["remote_f_windowsVNC", ip + "|" + "5900"]);
            }
          }

          _that.connectRet = ret;
          setTimeout(function () {
            // for test
            // ret = 0;
            if (ret == 0 || ret == -2023) {
              _that.doControlSuccess();
            } else {
              _that.showConnectFailed();
            }
          }, 500);
        } else if (_that.item.dtype == 999) {
          _that.connectRet = 0;
          _that.mappingPort =
            window.external.mapping && window.external.mapping(ip, port, rule);
          _that.closeConnectAlert(true);
          _that.showMappingResultAlert();
        } else if (_that.item.isNasWebPort) {
          if (
            (_that.dev.term &&
              _that.dev.term.httpRedirectHttps &&
              !_that.dev.term.nasHttpsWebPort) ||
            (_that.item.server_type == "https" && rule)
          ) {
            _that.showNasWebportFailedAlert();
          } else {
            _that.connectRet = 0;
            _that.mappingPort =
              window.external.mapping &&
              window.external.mapping(ip, port, rule);
            let url =
              _that.item.server_type + "://127.0.0.1:" + _that.mappingPort;
            window.external.openBrowser && window.external.openBrowser(url);
            _that.doControlSuccess();
          }
        } else {
          if (window.external.goBrowser) {
            if (
              _that.item.vendor == "Huawei" &&
              _that.dev.term.version > "1.1.1"
            ) {
              if (rule == 0) {
                setTimeout(function () {
                  _that.closeConnectAlert(true);
                  _that.showRuleModeAlert();
                }, 1000);
                return;
              }
              _that.sendUserlog(["remote_mode", ""]);
            }
            ret = window.external.goBrowser(ip, _that.item.port, rule);

            if (ret == 0 || ret == -2023) {
              _that.sendUserlog([
                "remote_s_windowsGoBrowser",
                ip + "|" + _that.item.port,
              ]);
            } else {
              _that.sendUserlog([
                "remote_f_windowsGoBrowser",
                ip + "|" + _that.item.port,
              ]);
            }
          }

          _that.connectRet = ret;
          setTimeout(function () {
            // for test
            // ret = 0;
            if (ret == 0 || ret == -2023) {
              _that.doControlSuccess();
            } else {
              _that.showConnectFailed();
            }
          }, 500);
        }
      } else if (_that.$store.state.client == "mac") {
        if (_that.item.port == 3389) {
          if (window.webkit.messageHandlers.goMstsc) {
            window.webkit.messageHandlers.goMstsc.postMessage({
              ip: ip,
              port: _that.item.port,
              rule: rule,
              cb: "goMstscCallback",
            });
          }
          // _that.closeConnectAlert(true);
          // _that.messageFlag = true;
          // _that.messageType = "showDownloadWindowsApp";
        } else if (_that.item.dtype == 999) {
          window.webkit.messageHandlers.mapping.postMessage({
            ip: ip,
            port: port,
            rule: rule,
            cb: "mappingCallback",
          });
        } else if (_that.item.isNasWebPort) {
          if (
            (_that.dev.term &&
              _that.dev.term.httpRedirectHttps &&
              !_that.dev.term.nasHttpsWebPort) ||
            (_that.item.server_type == "https" && rule)
          ) {
            _that.showNasWebportFailedAlert();
          } else {
            window.webkit.messageHandlers.mapping.postMessage({
              ip: ip,
              port: port,
              rule: rule,
              cb: "mappingNasWebportCallback",
            });
          }
        } else if (_that.item.port == 5900) {
          if (window.webkit.messageHandlers.goVnc) {
            window.webkit.messageHandlers.goVnc.postMessage({
              ip: ip,
              port: _that.item.port,
              rule: rule,
              cb: "goVncCallback",
            });
          }
        } else {
          if (window.webkit.messageHandlers.goBrowser) {
            if (
              _that.item.vendor == "Huawei" &&
              _that.dev.term.version > "1.1.1"
            ) {
              if (rule == 0) {
                setTimeout(function () {
                  _that.closeConnectAlert(true);
                  _that.showRuleModeAlert();
                }, 1000);
                return;
              }
              _that.sendUserlog(["remote_mode", ""]);
            }

            window.webkit.messageHandlers.goBrowser.postMessage({
              ip: ip,
              port: _that.item.port,
              rule: rule,
              cb: "goBrowserCallback",
            });
          }
        }
      } else {
        if (_that.item.port != 3389 && _that.item.port != 5900) {
          if (_that.item.isNasWebPort) {
            if (
              _that.dev.term &&
              _that.dev.term.httpRedirectHttps &&
              !_that.dev.term.nasHttpsWebPort
            ) {
              _that.showNasWebportFailedAlert();
              return;
            } else if (_that.item.server_type == "https") {
              _that.showNasWebportFailedAlert();
              return;
            }
          }
          if (
            _that.item.vendor == "Huawei" &&
            _that.dev.term.version > "1.1.1"
          ) {
            if (rule == 0) {
              setTimeout(function () {
                _that.closeConnectAlert(true);
                _that.showRuleModeAlert();
              }, 1000);
              return;
            }
            _that.sendUserlog(["remote_mode", ""]);
          }
          //获取网关
          _that.portal([
            _that.dev.peerid,
            function (err, data) {
              if (data && data.rtn == 0) {
                let accessToken = data.data.access_token;
                let authToken = data.data.auth_token;
                let addr = "https://" + data.data.addr;

                //建立通道
                _that.createTunnel([
                  _that.dev.peerid,
                  accessToken,
                  authToken,
                  addr,
                  function (err, data1) {
                    if (!err && data1 && data1.status == 1) {
                      //获取端口，打开新窗口

                      _that.startMapSrv([
                        _that.dev.peerid,
                        accessToken,
                        authToken,
                        ip,
                        _that.item.port,
                        addr,
                        rule,
                        function (err, data2) {
                          let reqLogData = {
                            callee: _that.dev.peerid,
                            authToken: authToken,
                            accessToken: accessToken,
                            svFwdIP: ip,
                            svFwdPort: _that.item.port,
                            addr: addr,
                            rule: rule,
                          };
                          if (data2 && data2.svMapPort) {
                            let httpType = "http";
                            if (data2.svMapPort == 443) {
                              httpType = "https";
                            }
                            let url =
                              httpType +
                              "://" +
                              data2.svMapHost +
                              ":" +
                              data2.svMapPort +
                              "/?jdcode=" +
                              encodeURIComponent(authToken);

                            let logObj = {
                              url: url,
                            };

                            _that.sendUserlog([
                              "remote_s_startMapSrv",
                              JSON.stringify(reqLogData) +
                                JSON.stringify(data2) +
                                JSON.stringify(logObj),
                            ]);
                            _that.$common
                              .bridge(_that.$store.state.client)
                              .openBrowser(url);
                            _that.doControlSuccess();
                          } else {
                            _that.sendUserlog([
                              "remote_f_startMapSrv",
                              JSON.stringify(reqLogData) +
                                JSON.stringify(data2),
                            ]);
                            _that.showConnectFailed();
                          }
                        },
                      ]);
                    } else {
                      _that.connectRet =
                        data1 && data1.status ? data1.status : "";
                      _that.showConnectFailed();
                    }
                  },
                ]);
              } else {
                _that.connectRet = data.rtn;
                _that.showConnectFailed();
              }
            },
          ]);
        } else {
          _that.closeConnectAlert(true);
          _that.messageFlag = true;
          _that.messageType = "showDownloadWindowsApp";
        }
      }
    },
    doControlSuccess: function () {
      let _that = this;
      if (_that.$store.state.user.vip_left > 0) {
        _that.closeConnectAlert();
      } else {
        if (_that.isVipServer || true) {
          _that.updateServerTimes([
            function (err, data) {
              let leftTimes =
                data && data.data && data.data.times ? data.data.times : 0;
              _that.$store.state.user.leftTimes = leftTimes;
              _that.closeConnectAlert();
            },
          ]);
        } else {
          _that.closeConnectAlert();
        }
        // _that.showServerTimes();
      }
    },
    showServerTimes: function () {
      let _that = this;
      _that.updateServerTimes([
        function (err, data) {
          let leftTimes =
            data && data.data && data.data.times ? data.data.times : 0;
          leftTimes = leftTimes >= 0 ? leftTimes : 0;
          _that.leftTimes = leftTimes;
          _that.$store.state.user.leftTimes = leftTimes;
          // 不显示剩余次数弹窗
          _that.showServerTimesTipsAlert();
          _that.closeConnectAlert();
        },
      ]);
    },
    openClick: function () {
      let _that = this;
      _that.sendUserlog(["wakeup_click", _that.item.mac]);
      let isIgnoreRemoteWakeupTips = localStorage.getItem(
        "ignoreRemoteWakeupTips"
      );
      if (isIgnoreRemoteWakeupTips) {
        _that.wakeupClick();
      } else {
        _that.showWakeUpTipsAlert();
      }
    },
    jumpBrowser: function () {
      let _that = this;
      let url = "http://127.0.0.1:" + _that.mappingPort;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
  },
  activated: function () {
    let _that = this;
    if (_that.type == "wakeup") {
      _that.openClick();
    } else {
      _that.controlClick();
    }
  },
  mounted: function () {
    let _that = this;

    console.log("mounted", _that.dev, _that.item);

    if (!(_that.dev && _that.dev.term && _that.dev.term.status == 1)) {
      if (_that.$store.state.client == "windows") {
        window.external.connectDevice &&
          window.external.connectDevice(_that.dev.peerid);
      } else if (_that.$store.state.client == "mac") {
        window.webkit.messageHandlers.connectDevice &&
          window.webkit.messageHandlers.connectDevice.postMessage({
            pid: _that.dev.peerid,
          });
      }
    }

    window.goBrowserCallback = function (data) {
      let ret = data.ret;
      _that.connectRet = ret;
      setTimeout(function () {
        if (ret == 0 || ret == -2023) {
          _that.doControlSuccess();
          _that.sendUserlog(["remote_s_macGoBrowser", JSON.stringify(data)]);
        } else {
          _that.showConnectFailed();
          _that.sendUserlog(["remote_f_macGoBrowser", JSON.stringify(data)]);
        }
      }, 500);
    };

    window.goVncCallback = function (data) {
      let ret = data.ret;
      let isHandle = data.isHandle;
      _that.connectRet = ret;
      setTimeout(function () {
        if (ret == 0 || ret == -2023) {
          if (isHandle) {
            _that.doControlSuccess();
            _that.sendUserlog(["remote_s_macVnc", JSON.stringify(data)]);
          } else {
            _that.closeConnectAlert(true);
            _that.messageFlag = true;
            _that.messageType = "showDownloadMacMstscApp";

            _that.sendUserlog(["remote_f_macVnc_MRD", JSON.stringify(data)]); //Microsoft Remote Desktop
          }
        } else {
          _that.showConnectFailed();

          _that.sendUserlog(["remote_f_macVnc", JSON.stringify(data)]);
        }
      }, 500);
    };

    window.goMstscCallback = function (data) {
      let ret = data.ret;
      let isHandle = data.isHandle;
      _that.connectRet = ret;
      setTimeout(function () {
        if (ret == 0 || ret == -2023) {
          if (isHandle) {
            _that.doControlSuccess();

            _that.sendUserlog(["remote_s_macDesktop", JSON.stringify(data)]);
          } else {
            _that.closeConnectAlert(true);
            _that.messageFlag = true;
            _that.messageType = "showDownloadMacMstscApp";

            _that.sendUserlog([
              "remote_f_macDesktop_MRD",
              JSON.stringify(data),
            ]); //Microsoft Remote Desktop
          }
        } else {
          _that.showConnectFailed();

          _that.sendUserlog(["remote_f_macDesktop", JSON.stringify(data)]);
        }
      }, 500);
    };

    window.mappingCallback = function (data) {
      _that.mappingPort = data.port;
      _that.closeConnectAlert(true);
      _that.showMappingResultAlert();
    };

    window.mappingNasWebportCallback = function (data) {
      _that.mappingPort = data.port;
      let url = _that.item.server_type + "://127.0.0.1:" + _that.mappingPort;
      if (window.webkit.messageHandlers.openBrowser) {
        window.webkit.messageHandlers.openBrowser.postMessage({
          url: url,
        });
      }
      _that.doControlSuccess();
    };

    // console.log("control type", _that.type, _that.item);
    if (_that.type == "wakeup") {
      _that.openClick();
    } else {
      _that.controlClick();
    }
  },
};
</script>

<style lang="less" scoped>
.control {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .diy-map-tip {
    width: 100%;
    height: 100%;
    background-color: rgba(194, 194, 194, 0.5);
    .diy-wrap {
      position: absolute;
      padding-top: 1px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 345px;
      height: 330px;
      background-image: linear-gradient(180deg, #f4f7ff 0%, #ffffff 19%);
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;
      .tip {
        position: absolute;
        left: 50%;
        top: 50%;
        // transform: translate(-50%, -50%);
        width: 100px;
        margin-left: -50px;
        margin-top: -18px;
        height: 36px;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        line-height: 36px;
        color: #ffffff;
        z-index: 11;
      }
      .close-icon {
        position: absolute;
        right: 0px;
        top: 0;
        padding: 16px;
        width: 24px;
        height: 24px;
        background-image: url("../../assets/remote/diyClose.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 24px 24px;
        cursor: pointer;
      }
      .diy-title {
        margin-top: 46px;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #143977;
      }
      .diy-text {
        margin-top: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
      .diy-text2 {
        position: relative;
        display: inline-block;
        margin-top: 18px;
        vertical-align: top;
        font-size: 14px;
        line-height: 24px;
        color: #666666;
      }
      .diy-text2::before {
        position: absolute;
        top: 11px;
        left: -104px;
        content: "";
        width: 76px;
        height: 1px;
        background-color: #dee0e4;
      }
      .diy-text2::after {
        position: absolute;
        top: 11px;
        right: -104px;
        content: "";
        width: 76px;
        height: 1px;
        background-color: #dee0e4;
      }
      .diy-text3 {
        margin: 0 auto;
        margin-top: 15px;
        width: 265px;
        height: 43px;
        line-height: 43px;
        background-color: #f6f8fb;
        border-radius: 4px;
        font-weight: 600;
        font-size: 20px;
        color: #18369f;
      }
      .diy-btns {
        margin-top: 28px;
        .btn {
          display: inline-block;
          vertical-align: top;
          width: 125px;
          height: 42px;
          line-height: 42px;
          background-image: linear-gradient(157deg, #243a5e 19%, #1c2f4d 90%);
          border-radius: 126px;
          font-size: 14px;
          color: #ffffff;
          cursor: pointer;
          .btn-icon {
            display: inline-block;
            margin-top: 13px;
            margin-right: 10px;
            vertical-align: top;
            width: 15px;
            height: 15px;
            background-image: url("../../assets/remote/diy1.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        .btn2 {
          margin-left: 15px;
          .btn-icon {
            margin-top: 11px;
            width: 18px;
            height: 18px;
            background-image: url("../../assets/remote/diy2.svg");
          }
        }
        .btn:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>